<template>
	<div class="wrapper">
		<div v-if="loading" class="text-center">
			<b-spinner label="Loading..." style="width: 3rem; height: 3rem;" variant="info"></b-spinner>
		</div>
		<div v-else class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<div>
						<genericTable :table-data="tableData" :filter="true" :fields="fields" :per-page=20 hover striped bordered small
													caption="<i class='icon-list'></i> List of purchase orders">
							<template v-slot:actions>
								<b-nav pills small class="float-right">
									<b-nav-item active @click="exportAsExcel()"><i class="fa fa-sign-out"></i> Export As Excel</b-nav-item>
								</b-nav>
							</template>
							<template v-slot:row-actions="row">
								<b-button v-if="row.row.item.delivery_status === 1" size="sm" variant="primary" class="mr-1" @click="viewDeliveryDetails(row.row.item.id)">
									<i class="icon-eye"></i> View
								</b-button>
								<b-button v-else-if="$store.getters.canWrite" size="sm" variant="secondary" class="mr-1" @click="editPurchaseOrder(row.row.item.id)">
									<i class="icon-pencil"></i> Edit
								</b-button>
							</template>
						</genericTable>
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import toastService from "@/services/toastService";
import genericTable from "@/components/GenericTable";
import purchaseOrderService from "@/services/purchaseOrderService";
import moment from "moment";

export default {
	name : "PurchaceOrderList",
	components : {
		"genericTable" : genericTable
	},
	data : function () {
		return {
			purchaseOrderList : [],
			fields: [
				{key: 'project_id', label: 'Project ID', sortable: true, class: 'text-center', searchable:true},
				{key: 'project_name', label: 'Project Name', sortable: true, class: 'text-center', searchable:true},
				{key: 'purchase_date', label: 'Date of Purchase', class: 'text-center'},
				{key: 'device_quantity', label: 'Device Quantity', class: 'text-center'},
				{key: 'unit_price', label: 'Unit Price', class: 'text-center'},
				{key: 'software_package_fee', label : 'Software Package Fee', class: 'text-center'},
				{key: 'total_amount', label : 'Total Amount', class: 'text-center'},
				{key: 'delivery_status', label: 'Delivery Status', class: 'text-center'},
				{key: 'delivery_date', label: 'Date of Delivery', class: 'text-center'},
				{key: 'warranty_last_date', label: 'Last Date of Warranty', class: 'text-center'},
				{key: 'actions', label: 'Actions', class : 'text-center'}
			],
			loading : false
		}
	},
	methods : {
		getAllPurchaseOrders : function () {
			this.loading = true;
			purchaseOrderService.getAllPurchaseOrders((data) => {
				this.createPurchaseOrderListTable(data);
				this.loading = false;
			}, (error) => {
				this.loading = false
				toastService.showErrorToast("Could not fetch purchase order list " + error);
			});
		},
		createPurchaseOrderListTable: function (data) {
			data.forEach((value, index) => {
				let row = new Object();
				let totalAmount = (value.unitPrice + value.softwarePackageFee) * value.deviceQuantity;
				row.id = value.id;
				row.project_id = value.projectId;
				row.project_name = value.projectName;
				row.purchase_date = moment(value.purchaseDate).format('DD-MM-YYYY');
				row.device_quantity = value.deviceQuantity;
				row.unit_price = value.unitPrice.toFixed(2);
				row.software_package_fee = value.softwarePackageFee.toFixed(2);
				row.total_amount = totalAmount.toFixed(2);
				row.delivery_status = value.deliveryStatus;
				row.delivery_date = (value.deliveryDate != null) ? moment(value.deliveryDate).format('DD-MM-YYYY') : "N/A";
				row.warranty_last_date = (value.warrantyLastDate != null) ? moment(value.warrantyLastDate).format('DD-MM-YYYY') : "N/A";
				this.purchaseOrderList.push(row);
			});
		},
		viewDeliveryDetails : function (purchaseOrderId) {
			this.$router.push("/purchase-orders/" + purchaseOrderId);
		},
		editPurchaseOrder : function (purchaseOrderId) {
			this.$router.push("/purchase-orders/edit/" + purchaseOrderId);
		},
		exportAsExcel : function () {
			purchaseOrderService.exportAsExcel((data) => {

			}, (error) => {
				toastService.showErrorToast("Could not export purchase order list.");
			});
		}
	},
	created() {
		this.getAllPurchaseOrders();
	},
	computed: {
		tableData : function () {
			return this.purchaseOrderList;
		}
	}
}
</script>

<style scoped>

</style>
